// theme-sources/js/core-ui/components/modal-dialog.js
import { trapFocus, removeTrapFocus } from "../../shared/utils";
import { publish, THEME_EVENTS } from "../../shared/events";

import { sectionLogger } from "./_logger";

const DEBUG = true;
const logger = sectionLogger("ModalOpener", DEBUG);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");
    if (!button) return;

    button.addEventListener("click", async () => {
      const selector = this.getAttribute("data-modal");
      const modal = document.querySelector(selector);
      if (!modal) return;

      if (typeof window.showCalculatorInModal === "function") {
        await window.showCalculatorInModal(selector);
      }

      modal.show(button);
    });
  }
}
if (!customElements.get("modal-opener")) {
  customElements.define("modal-opener", ModalOpener);
}

export default class ModalDialog extends HTMLElement {
  constructor() {
    super();

    this.onKeydown = this.onKeydown.bind(this);

    const closeBtn = this.querySelector('[id^="ModalClose-"]');
    if (closeBtn) {
      closeBtn.addEventListener("click", () => this.hide());
    }

    // clic sur l’overlay
    this.addEventListener("click", (event) => {
      if (event.target === this) this.hide();
    });

    // comportement Shopify media-modal
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        ) {
          this.hide();
        }
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;

    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");

    document.addEventListener("keydown", this.onKeydown);

    const dialog = this.querySelector('[role="dialog"]');
    if (dialog) {
      trapFocus(this, dialog);
    }
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");

    document.removeEventListener("keydown", this.onKeydown);
    removeTrapFocus(this.openedBy);

    this.dispatchEvent(new CustomEvent("modal:close"));
    /*publish(THEME_EVENTS.modalClose, {
      modal: this,
      id: this.id,
    });*/
  }

  onKeydown(event) {
    if (event.key === "Escape") {
      event.preventDefault();
      this.hide();
    }
  }
}
if (!customElements.get("modal-dialog")) {
  customElements.define("modal-dialog", ModalDialog);
}

async function showCalculatorInModal(
  modalSelector = "#PopupModal-{{ section_id }}",
) {
  const modal = document.querySelector(modalSelector);
  if (!modal) return;

  // évite les refetchs
  if (modal.hasAttribute("data-loaded")) return;

  const url = "/pages/calculateur-de-ration-lg";
  const response = await fetch(url);
  if (!response.ok) return;

  const html = await response.text();
  const doc = new DOMParser().parseFromString(html, "text/html");
  const source = doc.getElementById("rationCalculator2024");
  if (!source) return;

  const mount = modal.querySelector("#calculator2024");
  if (!mount) return;

  mount.innerHTML = source.innerHTML;
  modal.setAttribute("data-loaded", "true");
}
